<template>
  <div id="cuponPuntos" class="mx-3 border border-radius-15 mb-10" style="min-height: 750px;">
    <div class="text-right c-pointer mt-2" @click="$FModal.hide()">
      <i class="fa-solid fa-circle-xmark fa-2x  fg-gray"></i>
    </div>
    <template v-if="cargando">
      <div class="d-flex flex-justify-center mt-20">
        <div data-role="activity" data-type="cycle" data-style="color"></div>
      </div>
      <div class="d-flex flex-justify-center pt-2">
        <span>Cargando...</span>
      </div>
    </template>
    <template v-else>
      <template v-if="list_cupones">
        <div class="h6 text-bold">Cupones de puntos</div>
        <div class="row">
          <div class="cell-fs-6 text-center">
            <span>{{ puntos_disponibles.yidi_puntos | to_delimeter }}</span> <br>
            <span class="text-small">Yidi Puntos</span> <br>
            <button class="button link" v-if="creando_cupon" style="font-size: 10px;"
              @click="sum_puntos(null, false, true)">Todos <span class="mif-arrow-right ml-1"></span></button>
          </div>
          <div class="cell-fs-6 text-center">
            <span>{{ puntos_disponibles.puntos_categoria_disponible | to_delimeter }}</span> <br>
            <span class="text-small">Puntos Por Categoria</span> <br>
            <button class="button link" v-if="creando_cupon" style="font-size: 10px;"
              @click="sum_puntos(null, true, false)">Todos <span class="mif-arrow-right ml-1"></span></button>
          </div>
        </div>
        <div class="text-center" v-show="!creando_cupon">
          <button class="button rounded bg-darkBlue fg-white" @click="crearCupon()">Crear cupón</button>
          <button class="button rounded bg-darkBlue fg-white m-2" @click="view(false, false, true)">Depositar Cupones
          </button>
        </div>
        <template v-if="creando_cupon">
          <div class="row text-small mt-10">
            <div class="cell-fs-8">
              <div class="row">
                <div class="cell-fs-7">
                  <span class="text-medium"> Yidi Puntos: <br> <span class="text-light"> Maximo {{
                    puntos_disponibles.yidi_puntos | to_delimeter }}</span></span>
                </div>
                <div class="cell-fs-5">
                  <button class="button link" style="font-size: 10px;" v-if="puntos_disponibles.yidi_puntos > 0"
                    @click="sum_puntos(null, false, true)">Todos <span class="mif-arrow-right ml-1"></span></button>
                </div>
              </div>
            </div>
            <div class="cell-fs-4">
              <input type="number" id="cantYidiPuntos" v-model="cantYidiPuntos" @keyup="validarValor(false, true)"
                style="width: 100%; box-sizing: border-box;"
                :class="`border border-radius-10 pl-2 ${puntos_disponibles.yidi_puntos > 0 ? '' : 'disabled'}`">
            </div>

          </div>
          <div class="row text-small">
            <div class="cell-fs-6">
              <span class="text-medium"> Puntos Por Categoria:</span>
            </div>
          </div>
          <div class="row text-small ml-3" v-for="categoria in puntos_disponibles.puntos_categoria">
            <div class="cell-fs-8">
              <span class="text-medium">{{ categoria.categoria }}:</span>
              <button class="button link float-right" style="font-size: 10px;"
                @click="sum_puntos(categoria, false, false)">Todos
                <span class="mif-arrow-right ml-1"></span>
              </button>
              <br>
              <span class="text-light">Máximo {{ categoria.monto_disponible | to_delimeter }}</span>
            </div>
            <div class="cell-fs-4">
              <input type="number" :id="`categoria_${categoria.categoria_id}`" value="0"
                style="width: 100%; box-sizing: border-box;" @keyup="validarValor(true, false, categoria)"
                :class="`border border-radius-10 pl-2 ${categoria.monto_disponible > 0 ? '' : 'disabled'}`">
            </div>
          </div>

          <div class="text-right mt-2 text-medium mx-2" style="font-size: 14px;">
            Sumado: <span class="text-bold">{{ valorSumado | to_delimeter }}</span>
          </div>
          <div class="fg-darkBlue">
            <input type="checkbox" v-model="forOtherUser" data-role="switch"
              data-caption="<span style='font-size:10px;' class='text-upper'>Para alguien más</span> "
              data-material="true" style="font-size: 12px;">
          </div>
          <div class="container text-small" v-if="forOtherUser">
            <span class="text-small text-medium" style="">No. de socio:</span>
            <input type="text" class="border border-radius-10 w-75 " @keyup="getDataUserAssigned()" v-model="noSocio">
            <div class=" mt-2" v-if="noSocioValido && Object.keys(userAssigned).length > 0">
              <span class="text-medium ml-5">{{ userAssigned.no_patrocinador }} | {{ userAssigned.nombre_completo
                }}</span>
              <br>
              <span class="fg-orange text-medium">Los Cupones aplicados para alguien mas, generan una comision por
                manejo de cuenta </span>
            </div>
            <div class=" mt-2 text-center" v-if="!noSocioValido && noSocio.length > 4">
              <span class="fg-red">No. de socio invalido</span>
            </div>
          </div>

          <div class="text-right mt-2 text-medium mx-2" style="font-size: 14px;"
            v-if="valorFinal > 0 && (!forOtherUser || (forOtherUser && noSocioValido))">
            Importe de Cupon: <span class="text-bold" v-if="forOtherUser"><s>{{ valorSumado | to_delimeter }}</s>
              <span>{{ valorFinal | to_delimeter }}</span></span>
            <span class="text-bold" v-if="!forOtherUser">{{ valorFinal | to_delimeter }}</span>
          </div>
          <div class="text-right">
            <button class="button rounded bg-gray fg-white m-1" v-show="creando_cupon" @click="crearCupon()"><i
                class="fa-solid fa-circle-xmark"></i>
              Cancelar
            </button>
            <button class="button success rounded m-1" v-if="dataOK" @click="generar_cupon()">Generar cupón</button>
          </div>
        </template>
        <div class="h6 text-center text-medium mt-10" style="font-size: 14px;">Historial de cupones</div>
        <template v-if="Object.keys(historial_cupones).length > 0">
          <div class="row text-small text-bold text-center">
            <div class="cell-fs-3">Codigo</div>
            <div class="cell-fs-3">Fecha de creacion</div>
            <div class="cell-fs-2">Valor</div>
            <div class="cell-fs-2">Disponible</div>
            <div class="cell-fs-2">Status</div>
          </div>
          <div class="row text-small border-bottom border-radius-5 bd-gray" v-for="cupon in historial_cupones">
            <div class="cell-fs-3">
              <div class="fg-green text-right text-bold" style="font-size: 8px;" v-if="cupon.usado">Usado</div>
              <div class="fg-blue text-right text-bold" style="font-size: 8px;" v-if="cupon.en_uso">En Uso</div>
              <div class="fg-orange text-right text-bold" style="font-size: 8px;" v-if="cupon.sin_usar">Sin Usar</div>
              <div class="">
                {{ cupon.hex_code }}
                <div class="border border-radius-10 w-50 bg-blue fg-white c-pointer float-right text-center"
                  style="font-size: 11px;" @click="copyTEXT(cupon.hex_code)">Copiar
                </div>
              </div>
            </div>
            <div class="cell-fs-3 text-center">{{ cupon.fecha_creacion | to_date_format('MMM Do YY, h:mm:ss A') }}</div>
            <div class="cell-fs-2 text-center">{{ cupon.monto | to_delimeter }}</div>
            <div class="cell-fs-2 text-center">{{ cupon.monto_disponible | round(4) }}</div>
            <div class="cell-fs-2 c-pointer fg-darkBlue" @click="verDetalles(cupon)">
              <span class="mif-eye"></span> Ver
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center text-small text-light">No has creado ningún cupón</div>
        </template>
      </template>
      <template v-if="depositar_cupones">
        <div class="cell-fs-2">
          <button class="button link m-2" @click="view(true, false, false)">
            <span class="mif-arrow-left mif-2x"></span>
          </button>
        </div>
        <div class="h6 text-center text-bold">Depositar Cupones a Yidi Puntos</div>
        <div class="row">
          <div class="cell-fs-full text-center">
            <span>{{ puntos_disponibles.yidi_puntos }}</span> <br>
            <span class="text-small">Yidi Puntos Disponibles</span>
          </div>
        </div>
        <div class="row px-10 h-100">
          <div class="heading text-light">Ingresar cupón</div>
          <div class="content mt-2">
            <input type="text" name="" v-model="cupon_value" @paste="validarCupon()" @keyup="validarCupon()"
              placeholder="Codigo de cupón" id=""><br>
            <template v-if="Object.keys(cupon_data).length > 0">
              <template v-if="cupon_data.sin_usar || cupon_data.en_uso">
                <span class="text-light  text-small"> Se abonaran {{ cupon_data.monto_disponible | to_delimeter }} a tus
                  Yidi Puntos</span>
                <!--              <input type="text" name="" v-model="cupon_value_uso" placeholder="Monto a Abonar" id="">-->
                <div class="text-right" v-if="cupon_value_uso > 0">
                  <button class="button primary small rounded mt-1" @click="aplicarCupon()">Abonar a Yidi Puntos
                  </button>
                </div>
              </template>
              <template v-if="cupon_data.usado">
                <span class="text-bold text-small fg-orange"> El cupón ya fue aplicado o no es valido</span>
              </template>
            </template>
            <template v-if="Object.keys(cupon_data).length == 0">
              <span class="text-bold text-small fg-red"> El cupón no es valido o no eres el propietario</span>
            </template>
            <template v-if="depositando_cupon">
              <div class="d-flex flex-justify-center mt-10">
                <div data-role="activity" data-type="cycle" data-style="color"></div>
              </div>
              <div class="d-flex flex-justify-center pt-2">
                <span>Depositando Cupón ...</span>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-if="detalle_uso">
        <div class="cell-fs-2">
          <button class="button link m-2" @click="view(true, false, false)">
            <span class="mif-arrow-left mif-2x"></span>
          </button>
        </div>
        <div class="h6 text-bold">Depositar Cupones a Yidi Puntos</div>
        <div class="row">
          <div class="cell-fs-full text-center">
            <span>{{ puntos_disponibles.yidi_puntos }}</span> <br>
            <span class="text-small">Yidi Puntos Disponibles</span>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      puntos_disponibles: {},
      historial_cupones: [],
      creando_cupon: false,
      cantYidiPuntos: 0,
      cantPuntosCategoriaInicial: null,
      cantPuntosCategoria: null,
      list_cupones: true,
      detalle_uso: false,
      depositar_cupones: false,
      aplicar_cupon: false,
      cupon_value: '',
      cupon_data: {},
      cupon_value_uso: '',
      depositando_cupon: false,
      cargando: false,
      forOtherUser: false,
      save_cupon: false,
      noSocio: '',
      noSocioValido: false,
      userAssigned: {},
    };
  },
  props: {},
  mounted() {
    this.userId = this.user.id
    this.getPuntos()
  },
  destroyed() {
    this.$store.dispatch('getUser');
  },
  methods: {
    sum_puntos: function (categoria, all_categorias, yidi_puntos) {
      if (all_categorias) {
        this.puntos_disponibles.puntos_categoria.forEach((categoria) => {
          console.log(categoria.categoria)
          $("#categoria_" + categoria.categoria_id).val(categoria.monto_disponible)
          this.validarValor(true, false, categoria)
        });
      }
      if (categoria) {
        $("#categoria_" + categoria.categoria_id).val(categoria.monto_disponible)
        this.validarValor(true, false, categoria)
      }
      if (yidi_puntos) {
        this.cantYidiPuntos = this.puntos_disponibles.yidi_puntos.toFixed(2)
        this.validarValor(false, true)

      }
    },
    getPuntos: function () {
      this.cargando = true;
      this.axios.get('api/v2/puntos/cupon-data'
      ).then((response) => {
        this.puntos_disponibles = response.data.puntos_disponibles
        this.historial_cupones = response.data.historial_cupones
        this.cantPuntosCategoriaInicial = response.data.cantidad_puntos_categoria
        this.cantPuntosCategoria = response.data.cantidad_puntos_categoria
        setTimeout(() => {
          this.cargando = false;
        }, 300);
      }).catch(function (error) {
        this.cargando = false;
        console.log(error.response);
      });
    },
    view: function (list_cupones, detalle_uso, depositar_cupones) {
      this.aplicar_cupon = false
      this.cupon_value = ''
      this.cupon_data = {}
      this.cupon_value_uso = ''
      this.list_cupones = list_cupones;
      this.detalle_uso = detalle_uso;
      this.depositar_cupones = depositar_cupones;
    },
    crearCupon: function () {
      this.cantYidiPuntos = 0;
      this.cantPuntosCategoria = this.cantPuntosCategoriaInicial;
      this.creando_cupon = !this.creando_cupon;
    },
    validarCupon: function () {
      this.cupon_value_uso = 0;
      console.log(this.cupon_value)
      if (this.cupon_value.length >= 7) {
        this.axios.post(`/api/v2/puntos/cupones/get-info.json`, {}, {
          params: {
            cupon_value: this.cupon_value,
          }
        }).then((response) => {
          this.cupon_data = response.data
          this.cupon_value_uso = response.data.monto_disponible
        });
      }
    },
    aplicarCupon: function () {
      if (!this.depositando_cupon) {
        this.depositando_cupon = true;
        setTimeout(() => {
          this.axios.post(`/api/v2/puntos/cupones/depositar-cupon.json`, {}, {
            params: {
              cupon_id: this.cupon_data.id,
              user_id: this.forUserId,
            }
          }).then((response) => {
            this.puntos_disponibles = response.data.puntos_disponibles;
            this.historial_cupones = response.data.historial_cupones;
            this.cantidad_puntos_categoria_inicial = response.data.cantPuntosCategoria;
            this.cantidad_puntos_categoria = response.data.cantPuntosCategoria;
            this.depositando_cupon = false;
            this.view(true, false, false);
          }).catch(function (error) {
            this.depositando_cupon = false;
            console.log(error)
          });
          ;
        }, 3000)
      }
    },
    validarValor: function (by_categoria = true, by_puntos = false, categoria = null) {
      if (by_categoria) {
        console.log(categoria.categoria_id)
        const valor = parseFloat($("#categoria_" + categoria.categoria_id).val())
        let valor_a_asignar = 0
        if (valor <= categoria.monto_disponible) {
          valor_a_asignar = valor
        } else {
          $("#categoria_" + categoria.categoria_id).val('')
        }
        this.cantPuntosCategoria.find(item => item.id == categoria.categoria_id).valor = valor_a_asignar
      } else {
        const puntos_disponibles = this.puntos_disponibles.yidi_puntos

        console.log("valida Yidi Puntos")
        if (this.cantYidiPuntos > puntos_disponibles) {
          //   this.cantYidiPuntos = this.cantYidiPuntos
          // } else {
          this.cantYidiPuntos = puntos_disponibles
        }
      }
      this.$forceUpdate()
    },
    generar_cupon: function () {
      if (!this.save_cupon) {
        this.save_cupon = true;
        this.axios.post('api/v2/puntos/cupones/create.json', {
          cantidad_puntos_categoria: this.cantPuntosCategoria,
          yidi_puntos: this.cantYidiPuntos,
          valorSumado: this.valorSumado,
          user_id: this.userAssigned.id,
        }).then((response) => {
          this.getPuntos()
          this.crearCupon()
          this.save_cupon = false;
        }).catch(function (error) {
          this.save_cupon = false;
          console.log(error)
        });
      }

    },
    getDataUserAssigned: async function () {
      if (this.noSocio.length > 6) {
        await this.axios.get(`/api/v2/puntos/cupones/get-info-user.json`, {
          params: {
            no_socio: this.noSocio,
          }
        }).then((response) => {
          this.userAssigned = {}
          this.noSocioValido = false
          if (response.data) {
            this.userAssigned = response.data
            this.noSocioValido = true
          }
        }).catch(function (error) {
          console.log(error)
        })
      }
    },
    verDetalles: function (cupon) {
      this.$swal({
        title: `Cupón ${cupon.hex_code}`,
        text: `Asignado a: ${cupon.usuario_asignado}`
      })
    }
  },
  computed: {
    forUserId() {
      return this.user.id
    },
    valorSumado: function () {
      let sum = 0
      let yidi_puntos = this.cantYidiPuntos > 0 ? parseFloat(this.cantYidiPuntos) : 0
      for (let i = 0; i < this.cantPuntosCategoria.length; i++) {
        sum += (parseFloat(this.cantPuntosCategoria[i].valor))
      }
      sum += yidi_puntos
      sum = sum.toFixed(2)
      return sum
    },
    valorFinal: function () {
      return this.valorSumado - (this.forOtherUser ? (this.valorSumado / 100) * 30 : 0)
    },
    dataOK: function () {
      return this.valorFinal > 0 && (!this.forOtherUser || (this.forOtherUser && this.noSocioValido))
    }
  },
  watch: {}
};
</script>

<style></style>
